export default "__VITE_ASSET__BWOFQpII__"